import {
  INICIA_NOTIFICACAO,
  CANCELA_EDICAO,
  SALVA_NOTIFICACAO,
  REMOVE_NOTIFICACAO,
  NOVO_NOTIFICACAO,
  BUSCA_NOTIFICACAO_EDICAO,
  INICIO_NOTIFICACAO_SUCESSO,
  SALVA_NOTIFICACAO_SUCESSO,
  REMOVE_NOTIFICACAO_SUCESSO,
  BUSCA_NOTIFICACAO_EDICAO_SUCESSO,
  ATUALIZA_NOTIFICACAO,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_NOTIFICACAO,
  LISTA_NOTIFICACAO_SUCESSO,
  SETAR_IMAGEM_NOTIFICACAO,
  LIMPAR_NOTIFICACAO,
  NOTIFICACAO_ALTERACAO_CHECK,
  NOTIFICACAO_LISTA_ESCOLAS_SUCESSO,
  NOTIFICACAO_LISTA_ESCOLAS,
  NOTIFICACAO_LISTA_CATEGORIAS,
  NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO,
  NOTIFICACAO_LISTA_TURMAS_SUCESSO,
  NOTIFICACAO_LISTA_TURMAS,
  NOTIFICACAO_ALTERACAO_DATA
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/

export const iniciaNotificacao = () => {
  return {
    type: INICIA_NOTIFICACAO
  };
};

export const salvaNotificacao = (aluno) => {
  return {
    type: SALVA_NOTIFICACAO,
    payload: aluno
  };
};

// Opcional: ação explícita para atualizar aluno (se quisermos separar do SALVA)
export const atualizaNotificacao = (aluno) => {
  return {
    type: ATUALIZA_NOTIFICACAO,
    payload: aluno
  };
};

export const removeNotificacao = (id) => {
  return {
    type: REMOVE_NOTIFICACAO,
    payload: id
  };
};

export const listaNotificacao = (nome) => {
  if (nome == undefined) {
    nome = "";
  }

  return {
    type: LISTA_NOTIFICACAO,
    payload: { nome }
  };
};
export const cancelaEdicao = () => {
  return {
    type: CANCELA_EDICAO
  };
};

/*#############################################################################################*/
/* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/

export const novoNotificacao = () => {
  return {
    type: NOVO_NOTIFICACAO
  };
};

export const buscaNotificacaoEdicao = (id) => {
  return {
    type: BUSCA_NOTIFICACAO_EDICAO,
    payload: id
  };
};

/*#############################################################################################*/
/* --------------------------- Actions de respostas actions anteriores ------------------------*/  

export const inicioNotificacaoSucesso = (notificacoes)=> {
  return {
    type: INICIO_NOTIFICACAO_SUCESSO,
    payload:  notificacoes
  }
};

export const salvaNotificacaoSucesso = (mensagem) => {
  return {
    type: SALVA_NOTIFICACAO_SUCESSO,
    payload: mensagem
  }
};

export const removeNotificacaoSucesso = (mensagem) => {
  return {
    type: REMOVE_NOTIFICACAO_SUCESSO,
    payload: mensagem
  }
};  

export const buscaNotificacaoEdicaoSucesso = (aluno) => {
  return {
    type: BUSCA_NOTIFICACAO_EDICAO_SUCESSO,
    payload: aluno
  };
}; 

export const setarImagemNotificacao = (imagem) => {

  return {
    type: SETAR_IMAGEM_NOTIFICACAO,
    payload: { imagem }
  };
}

export const listaNotificacaoSucesso = (aluno) => {
  return {
    type: LISTA_NOTIFICACAO_SUCESSO,
    payload: { aluno }
  };
};

export const limparFiltroNotificacao = () => {
  return {
    type: LIMPAR_NOTIFICACAO,
  };
};

export const listaEscolas = () => {
  return {
    type: NOTIFICACAO_LISTA_ESCOLAS
  };
};

export const listaEscolasSucesso = (escolas) => {
  return {
    type: NOTIFICACAO_LISTA_ESCOLAS_SUCESSO,
    payload: escolas
  };
};

export const listaCategorias = () => {
  return {
    type: NOTIFICACAO_LISTA_CATEGORIAS
  };
};

export const listaCategoriasSucesso = (categorias) => {
  return {
    type: NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO,
    payload: categorias
  };
};

export const listaTurmas = (escolaId) => {
  return {
    type: NOTIFICACAO_LISTA_TURMAS,
    payload: escolaId
  };
};

export const listaTurmasSucesso = (turmas) => {
  return {
    type: NOTIFICACAO_LISTA_TURMAS_SUCESSO,
    payload: turmas
  };
};
/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/ 

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const onChangeCheckEnvio = (nomeCheck, value) => {
  return {
    type: NOTIFICACAO_ALTERACAO_CHECK,
    payload: { nomeCheck: [nomeCheck], valor: value }
  }
};
export const onChangeCheckDataEnvio = (name, date, compoeIntervalo, tipo, valorComparacao)=> {
  return {
    type: NOTIFICACAO_ALTERACAO_DATA,
    payload: { name, date }
  }
};
